import "./NoexistingAccountModal.less";

import React, { Component } from "react";
import { translate } from "react-i18next";
import queryString from "query-string";
import { Link, withRouter } from "react-router-dom";
import $ from "jquery";

class NoExistingAccountModal extends Component {

    componentDidMount() {
        if (this.props.show) {
            $("#no-existing-account-modal").modal("show");
        } else {
            $("#no-existing-account-modal").modal("hide");
        }
    }

    componentWillUnmount() {
        $("#select-profile-modal").modal("hide");
    }

    componentDidUpdate(prevProps) {
        if (this.props.show !== prevProps.show) {
            if (this.props.show) {
                $("#no-existing-account-modal").modal("show");
            } else {
                $("#no-existing-account-modal").modal("hide");
            }
        }
    }

    render() {
        const t = this.props.t;

        const currentQuery = queryString.parse(window.location.search);
        const returnUrl = currentQuery.returnUrl;
        const query = queryString.stringify({ returnUrl });
        const provider = currentQuery.provider || "";

        const modal = (
            <div className="modal fade" id="no-existing-account-modal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">
                                {t("title")}
                            </h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <div className="description-container">{t("description", { user: currentQuery.username, provider: provider.indexOf('Knooppunt') === 0 ? t(provider.toLowerCase()) : provider })}</div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button className="button-bg" onClick={() => window.location.href = '/registration' }>
                                {t("registerNow")}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );

        if (this.props.show) {
            return modal;
        } else {
            return null;
        }
    }
}

const translateNoExistingAccountModal = withRouter(translate("noExistingAccount")(NoExistingAccountModal));

export { translateNoExistingAccountModal as NoExistingAccountModal };



// WEBPACK FOOTER //
// ./src/components/Modals/NoExistingAccountModal/NoExistingAccountModal.js